// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1VS7X","buttons":"styles_buttons__2aGjH"};